
import messages from '../translations';

let idiomas = new Object();

for(let lang in messages){
	idiomas[lang] = messages[lang].enlaces;
}

let langSelected = "es";

export function langdetector() {

	let path = location.pathname;

	if(path == "/" || path == "/404"){

		langSelected = navigator.language.substring(0, 2);

	}else{

		path = '/'+path.split("/")[1];

		for(let lang in idiomas){

			let array = Object.entries(idiomas[lang]);

			(array.some(e => e[1] == path)) ? langSelected = lang : '';

		}

	}

	return langSelected;




}


// WEBPACK FOOTER //
// ./src/langdetector/index.js